// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602171133/js/" + chunkId + "." + {"44":"510e5212","225":"83c9fe54","481":"810e15b4","486":"c8a5fee5","770":"f259dbc6"}[chunkId] + ".0.9944999475746423.chunk.js";
};